module.exports = __webpack_public_path__ + "static/media/core-ts.8a793b20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/core-ts.png
// module id = 128
// module chunks = 0